var _class, _SharePanel;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from "classnames";
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import Box from "../../../../Styled/Box";
import Spacing from "../../../../Styled/Spacing";
import Text from "../../../../Styled/Text";
import { canShorten } from "./BuildShareLink";
import Styles from "./share-panel.scss";
import { SharePanelContent } from "./SharePanelContent";
import { ShareUrl } from "./ShareUrl";
import MenuPanel from "../../../StandardUserInterface/customizable/MenuPanel";
import StorySharePanel from "./StorySharePanel";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let SharePanel = observer(_class = (_SharePanel = class SharePanel extends Component {
  constructor(props) {
    super(props);
    this.changeOpenState = this.changeOpenState.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.state = {
      isOpen: false
    };
  }
  changeOpenState(open) {
    this.setState({
      isOpen: open
    });
    if (open) {
      if (this.props.catalogShare || this.props.storyShare) {
        this.props.viewState.shareModalIsVisible = true;
      }
    }
  }
  closePanel() {
    this.setState({
      isOpen: false
    });
  }
  renderContent() {
    const {
      terria,
      viewState,
      t
    } = this.props;
    if (this.props.catalogShare) {
      return /*#__PURE__*/_jsxs(Box, {
        fullWidth: true,
        column: true,
        paddedRatio: 3,
        children: [/*#__PURE__*/_jsx(Text, {
          medium: true,
          children: t("clipboard.shareURL")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 1
        }), /*#__PURE__*/_jsx(ShareUrl, {
          terria: terria,
          viewState: viewState,
          includeStories: true,
          shouldShorten: shouldShorten(terria)
        })]
      });
    } else if (this.props.storyShare) {
      return /*#__PURE__*/_jsxs(Box, {
        fullWidth: true,
        column: true,
        paddedRatio: 3,
        children: [/*#__PURE__*/_jsx(Text, {
          medium: true,
          children: t("share.shareStoryLink")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 1
        }), /*#__PURE__*/_jsx(ShareUrl, {
          terria: terria,
          viewState: viewState,
          includeStories: true,
          shouldShorten: shouldShorten(terria)
        })]
      });
    } else {
      return /*#__PURE__*/_jsx(SharePanelContent, {
        terria: terria,
        viewState: viewState,
        closePanel: this.closePanel
      });
    }
  }
  render() {
    const {
      t
    } = this.props;
    const {
      catalogShare,
      storyShare,
      catalogShareWithoutText,
      modalWidth
    } = this.props;
    const dropdownTheme = {
      btn: classNames({
        [Styles.btnCatalogShare]: catalogShare,
        [Styles.btnWithoutText]: catalogShareWithoutText
      }),
      outer: classNames(Styles.sharePanel, {
        [Styles.catalogShare]: catalogShare,
        [Styles.storyShare]: storyShare
      }),
      inner: classNames(Styles.dropdownInner, {
        [Styles.storyShareInner]: storyShare
      }),
      icon: "share"
    };
    const btnText = catalogShare ? t("share.btnCatalogShareText") : storyShare ? t("share.btnStoryShareText") : t("share.btnMapShareText");
    const btnTitle = catalogShare ? t("share.btnCatalogShareTitle") : storyShare ? t("share.btnStoryShareTitle") : t("share.btnMapShareTitle");
    return !storyShare ?
    /*#__PURE__*/
    //@ts-expect-error - not yet ready to tackle tsfying MenuPanel
    _jsx(MenuPanel, {
      theme: dropdownTheme,
      btnText: catalogShareWithoutText ? null : btnText,
      viewState: this.props.viewState,
      btnTitle: btnTitle,
      isOpen: this.state.isOpen,
      onOpenChanged: this.changeOpenState,
      showDropdownAsModal: catalogShare,
      modalWidth: modalWidth,
      smallScreen: this.props.viewState.useSmallScreenInterface,
      onDismissed: () => {
        if (catalogShare) this.props.viewState.shareModalIsVisible = false;
      },
      onUserClick: this.props.onUserClick,
      disableCloseOnFocusLoss: this.props.viewState.retainSharePanel,
      children: this.state.isOpen && this.renderContent()
    }) : /*#__PURE__*/_jsx(StorySharePanel, {
      btnText: catalogShareWithoutText ? null : btnText,
      viewState: this.props.viewState,
      btnTitle: btnTitle,
      isOpen: this.state.isOpen
      //@ts-expect-error - not yet ready to tackle tsfying StorySharePanel
      ,
      onOpenChanged: this.changeOpenState,
      showDropdownAsModal: storyShare,
      modalWidth: modalWidth,
      smallScreen: this.props.viewState.useSmallScreenInterface,
      btnDisabled: this.props.btnDisabled,
      onDismissed: () => {
        if (storyShare) this.props.viewState.shareModalIsVisible = false;
      },
      onUserClick: this.props.onUserClick,
      children: this.state.isOpen && this.renderContent()
    });
  }
}, _defineProperty(_SharePanel, "displayName", "SharePanel"), _SharePanel)) || _class;
export default withTranslation()(SharePanel);
export function shouldShorten(terria) {
  var _stringToBool;
  return (_stringToBool = stringToBool(terria.getLocalProperty("shortenShareUrls"))) !== null && _stringToBool !== void 0 ? _stringToBool : !!canShorten(terria);
}
function stringToBool(s) {
  if (s === true) return true;
  if (s === false) return false;
  if (s === "true") return true;
  if (s === "false") return false;
  return undefined;
}